import dayjs from '../../../helpers/dates';
import { startCase } from 'lodash';
import { formatCurrencyOnBlur } from '../../../helpers/utils';

export const getOpportunityReviewExcelData = (project: any) => {
  const {
    description,
    previousFunding,
    deadline,
    expected_response,
    deadline_type,
    submission_link,
    submission_username,
    submission_password,
    submission_notes,
    award_start,
    fundedProgram,
    estimated_hours,
    funder,
    actions,
    client,
    contacts,
  } = project;

  const LOIs = (actions || []).filter((action) => action.type === 'LOI');
  const LOIDeadline =
    LOIs.length > 0
      ? LOIs.reduce((acc, action) => {
          const aDate = new Date(action.deadline);
          const bDate = new Date(acc.deadline);
          return aDate > bDate ? action : acc;
        }).deadline
      : null;

  const formatDate = (val: any) =>
    val ? dayjs(val).format('YYYY-MM-DD') : '-';

  const detailsSheet = [
    ['Project Details'],
    ['Client', client?.name || '-'],
    ['Project', description || '-'],
    ['Submission Link', submission_link || '-'],
    ['Submission Username', submission_username || '-'],
    ['Submission Password', submission_password || '-'],
    ['Submission Notes', submission_notes || '-'],
    ['Funder Name', funder?.name || '-'],
    ['Funder Website', funder?.website || '-'],
    ['Funder Contact', funder?.phone || '-'],
    [
      'Previous Funding Received',
      formatCurrencyOnBlur((previousFunding || 0).toString()),
    ],
    ['LOI Due Date', formatDate(LOIDeadline)],
    ['Application Due Date', formatDate(deadline)],
    ['Expected Response Date', formatDate(expected_response)],
    ['Deadline Frequency', deadline_type ? startCase(deadline_type) : '-'],
    ['Project Begin Date', formatDate(award_start)],
    ['Program to be Funded', fundedProgram?.name || '-'],
    ['Est Hours for Preparation', estimated_hours || '-'],
  ];

  const teamRows = (contacts || []).map((c) => [
    c.full_name || '',
    c.email || '',
    c.phone || '',
  ]);

  const teamSheet = [['Name', 'Email', 'Phone'], ...teamRows];

  const actionRows = (actions || []).map((a) => [
    a.title || '',
    a.status || '',
    a.type || '',
    a.deadline || '',
    a.name || '',
  ]);

  const actionSheet = [
    ['Title', 'Status', 'Type', 'Deadline', 'Assignee'],
    ...actionRows,
  ];

  return [
    { name: 'Project Details', data: detailsSheet },
    { name: 'Team', data: teamSheet },
    { name: 'Action Items', data: actionSheet },
  ];
};
